var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { apiOMM } from '../axios-client';
import { OMM_EDIT_DELIVERY_ADDRESS_APPIFY_PATH, OMM_GUEST_DELIVERY_ADDRESS_APPIFY_PATH, OMM_AVAILABLE_DELIVERY_SLOTS_PATH, OMM_AVAILABLE_DELIVERY_SLOTS_GUEST_PATH, OMM_AVAILABLE_FULFILLMENT_OPTIONS_GUEST_PATH, OMM_AVAILABLE_FULFILLMENT_OPTIONS_PATH, } from '../../constants/paths';
import { getHost } from '../../utils/general';
/** Assigning serviceMeshUrl directly to bypass local issue where baseUrl in config is being overridden */
/** @see {@link apiCMS} */
var baseurl = getHost();
export var OmmEditDeliveryAddressAppifyApi = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    var path = isAuthTHDUser
        ? OMM_EDIT_DELIVERY_ADDRESS_APPIFY_PATH
        : OMM_GUEST_DELIVERY_ADDRESS_APPIFY_PATH;
    var config = {};
    if (!isAuthTHDUser && xAuthGuestToken && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': xAuthGuestToken,
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { headers: { parentTraceId: traceId } };
    }
    return apiOMM.post(path, request, __assign(__assign({}, config), { baseURL: baseurl }));
};
export var OmmAvailableDeliverySlotsApi = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    var path = isAuthTHDUser
        ? OMM_AVAILABLE_DELIVERY_SLOTS_PATH
        : OMM_AVAILABLE_DELIVERY_SLOTS_GUEST_PATH;
    var config = {};
    if (!isAuthTHDUser && xAuthGuestToken && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': xAuthGuestToken,
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { headers: { parentTraceId: traceId } };
    }
    return apiOMM.post(path, request, __assign(__assign({}, config), { baseURL: baseurl }));
};
export var OmmAvailableFulfillmentOptionsApi = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    var path = isAuthTHDUser
        ? OMM_AVAILABLE_FULFILLMENT_OPTIONS_PATH
        : OMM_AVAILABLE_FULFILLMENT_OPTIONS_GUEST_PATH;
    var config = {};
    if (!isAuthTHDUser && xAuthGuestToken && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': xAuthGuestToken,
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { headers: { parentTraceId: traceId } };
    }
    return apiOMM.post(path, request, __assign(__assign({}, config), { baseURL: baseurl }));
};
